import { Species } from './../_models/species';
import { Pelage } from './../_models/pelage';
import { Gender } from './../_models/gender';

export class Converters {

    public static ConvertGender(data: Array<object>): Array<Gender> {
        const converted: Array<Gender> = [];

        data.forEach(element => {
            converted.push(new Gender(element));
        });

        return converted;
    }

    public static ConvertSpecies(data: Array<object>): Array<Species> {
        const converted: Array<Species> = [];

        data.forEach(element => {
            converted.push(new Species(element));
        });

        return converted;
    }

    public static ConvertPelage(data: Array<object>): Array<Pelage> {
        const converted: Array<Pelage> = [];

        data.forEach(element => {
            converted.push(new Pelage(element));
        });

        return converted;
    }

}
